// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullAnalysisFileRecord{
    padding: 12px 0px;
}

.FullAnalysisFileRecord_head{
    display: flex;
    gap: 8px;
    margin-bottom: 10px;
}

.FullAnalysisFileRecord_head_avatar{
    width: 32px;
    height: 32px;
    border-radius: 100%;
    flex-shrink: 0;
    background-color: #ccc;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
              
.FullAnalysisFileRecord_head_right{
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.FullAnalysisFileRecord_head_right_top{
    display: flex;
    align-items: baseline;
    gap: 4px;
}

.FullAnalysisFileRecord_head_name{
    font-weight: 800;
    font-size: 12px;
    line-height: 16px;

    color: #1B1B1B;
}
                         
.FullAnalysisFileRecord_head_tags{
    display: flex;
    gap: 4px
}

.FullAnalysisFileRecord_head_tag{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1px 4px;
    background: #DFDFDF;
    border-radius: 3px;

    font-style: normal;
    font-weight: 500;
    font-size: 9px;
    line-height: 11px;

    color: #2E2E2E;
    opacity: 0.7;
    text-transform: uppercase;
}
                    
.FullAnalysisFileRecord_head_date{
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    color: #2E2E2E;

    opacity: 0.7;
}                           
                        
.FullAnalysisFileRecord_head_action{
    font-style: italic;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;

    color: #131313;
}                
                
.FullAnalysisFileRecord_content{
    margin-left: 40px;
    display: flex;
    gap: 9px;
    flex-direction: column;
}

.FullAnalysisFileRecord_content_quote{
    border-left: 3px solid #FFA825;
    padding-left: 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;

    color: #000000;
}

.FullAnalysisFileRecord_content_quote_text{
    margin-bottom: 6px;
}

.FullAnalysisFileRecord_content_title{
    font-weight: 700;
}

.FullAnalysisFileRecord_content_text{

}
                        
.FullAnalysisFileRecord_content_quote_text--collapsed {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.FullAnalysisFileRecord_content_showMore{
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #757575;
    cursor: pointer;
    margin-top: 4px;
    user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/fullAnalysis/FullAnalysisFile.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,sBAAsB;;IAEtB,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;;IAElB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;;IAEjB,cAAc;IACd,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;;IAEd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".FullAnalysisFileRecord{\n    padding: 12px 0px;\n}\n\n.FullAnalysisFileRecord_head{\n    display: flex;\n    gap: 8px;\n    margin-bottom: 10px;\n}\n\n.FullAnalysisFileRecord_head_avatar{\n    width: 32px;\n    height: 32px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-color: #ccc;\n\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n              \n.FullAnalysisFileRecord_head_right{\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.FullAnalysisFileRecord_head_right_top{\n    display: flex;\n    align-items: baseline;\n    gap: 4px;\n}\n\n.FullAnalysisFileRecord_head_name{\n    font-weight: 800;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #1B1B1B;\n}\n                         \n.FullAnalysisFileRecord_head_tags{\n    display: flex;\n    gap: 4px\n}\n\n.FullAnalysisFileRecord_head_tag{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1px 4px;\n    background: #DFDFDF;\n    border-radius: 3px;\n\n    font-style: normal;\n    font-weight: 500;\n    font-size: 9px;\n    line-height: 11px;\n\n    color: #2E2E2E;\n    opacity: 0.7;\n    text-transform: uppercase;\n}\n                    \n.FullAnalysisFileRecord_head_date{\n    font-weight: 400;\n    font-size: 10px;\n    line-height: 14px;\n    color: #2E2E2E;\n\n    opacity: 0.7;\n}                           \n                        \n.FullAnalysisFileRecord_head_action{\n    font-style: italic;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #131313;\n}                \n                \n.FullAnalysisFileRecord_content{\n    margin-left: 40px;\n    display: flex;\n    gap: 9px;\n    flex-direction: column;\n}\n\n.FullAnalysisFileRecord_content_quote{\n    border-left: 3px solid #FFA825;\n    padding-left: 12px;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #000000;\n}\n\n.FullAnalysisFileRecord_content_quote_text{\n    margin-bottom: 6px;\n}\n\n.FullAnalysisFileRecord_content_title{\n    font-weight: 700;\n}\n\n.FullAnalysisFileRecord_content_text{\n\n}\n                        \n.FullAnalysisFileRecord_content_quote_text--collapsed {\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.FullAnalysisFileRecord_content_showMore{\n    font-style: normal;\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 16px;\n    color: #757575;\n    cursor: pointer;\n    margin-top: 4px;\n    user-select: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
